import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './Header.scss';
import classNames from 'classnames';
import logo from 'images/logo-header.png';
// import CategoriesDropdown from './CategoriesDropdown';
import { loadCategories } from 'actions/categories';
import UserInfo from './UserInfo';

class Header extends React.Component {
  static propTypes = {
    categories: PropTypes.array,
    loadCategories: PropTypes.func
  };

  componentDidMount() {
    // const { loadCategories } = this.props;
    // loadCategories('Marketplace');
  }

  render() {
    const { className /* categories */ } = this.props;

    return (
      <div className={classNames('navbar navbar-dark navbar-expand-lg', className)}>
        <div className="container">
          <Link to="/">
            <img src={logo} className="brand" alt="Doodly Marketplace" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#headerNav"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="headerNav">
            <ul className="navbar-nav ml-auto d-flex align-items-center">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>
              {/* <CategoriesDropdown {...{ categories }} /> */}
              <UserInfo />
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.categories
});
const mapDispatchToProps = dispatch => ({
  loadCategories: type => dispatch(loadCategories(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
